var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_311_1384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.08984 0V5.56641C7.08984 10.6833 10.4283 15.0334 15 16.6311C19.5717 15.0334 22.9102 10.6833 22.9102 5.56641V0H7.08984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71127 11.4737C3.85975 9.104 2.02758 5.62395 1.78529 1.75781H5.33203V0H0V0.878906C0 2.66695 0.301523 4.4202 0.89625 6.08988C1.47105 7.70361 2.30607 9.20391 3.37811 10.5491C4.96471 12.54 7.02685 14.1112 9.33908 15.1204C8.26529 14.0582 7.37678 12.8244 6.71127 11.4737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.668 0V1.75781H28.2147C27.9725 5.62395 26.1403 9.104 23.2888 11.4737C22.6233 12.8244 21.7347 14.0582 20.6609 15.1204C22.9731 14.1112 25.0353 12.54 26.6219 10.5491C27.694 9.20391 28.529 7.70361 29.1037 6.08988C29.6985 4.4202 30 2.66695 30 0.878906V0H24.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7383 28.2421V21.2108H16.7578V17.8159C16.3754 17.9909 15.9827 18.1497 15.5799 18.2905L15 18.4931L14.4201 18.2905C14.0173 18.1497 13.6246 17.9909 13.2422 17.8159V21.2108H8.26172V28.2421H6.50391V29.9999H23.4961V28.2421H21.7383ZM17.6367 25.8983H12.3633V24.1405H17.6367V25.8983Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_1384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.a09453bea8eb9d8db58e14e88091f150.svg";
export { ForwardRef as ReactComponent };